const styles = theme => ({
  container: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    gap: '24px',
    paddingTop: '40px',
  },
  centerWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',
  },
})

export default styles
